// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_PARTS_FAILED_MODE
});

export const updateDownTimeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'downtime',
    type: actions.UPDATE_CLAIM_PARTS_DOWN_TIME
});

export const updatePartsClaimFailedArea = value => ({
    property: 'failureArea',
    type: actions.UPDATE_CLAIM_PARTS_FAILED_AREA,
    value
});

export const updatePartsClaimPartSerialNumber = value => ({
    property: 'failurePartSerialNumber',
    type: actions.UPDATE_CLAIM_PARTS_PART_SERIAL_NUMBER,
    value
});

export const updatePartsClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_PARTS_FAILED_MODE_COMMENTS,
    value
});

export const updatePartsClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_PARTS_DTAC_CASE,
    value
});

export const updatePartsClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_PARTS_DTAC_SOLUTION,
    value
});

export const updatePartsClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_PARTS_OPERATORS_COMPLAINT,
    value
});

export const updatePartsClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_PARTS_COMPLAINT_CAUSE,
    value
});

export const updatePartsClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_PARTS_COMPLAINT_CORRECTION,
    value
});

export const updatePartsClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_PARTS_OPERATORS_COMMENTS,
    value
});

export const updatePartsClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_PARTS_BASIS_FOR_SETTLEMENT,
    value
});



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/failure-panel.js